import { createSlice } from '@reduxjs/toolkit';

const projectAssignSlice = createSlice({
  name: 'assignSlice',
  initialState: {
    omProjectAssignHardwareState: [],
    employeesAssignedRefresh: false,
    employeesAssignedStateRefresh: "",
  },
  reducers: {
    setOmProjectAssignHardwareState: (state, action) => {
      state.omProjectAssignHardwareState = action.payload;
    },
    triggerEmployeesAssignedRefresh: (state) => {
      state.employeesAssignedRefresh = !state.employeesAssignedRefresh;
    },
    triggerEmployeesAssignedStateRefresh: (state) => {
      state.employeesAssignedStateRefresh = !state.employeesAssignedStateRefresh;
    },
  },
});

export const { 
  setOmProjectAssignHardwareState, 
  triggerEmployeesAssignedRefresh, 
  triggerEmployeesAssignedStateRefresh
} = projectAssignSlice.actions;
export default projectAssignSlice.reducer;
